import { useMutation } from "@tanstack/react-query";

import { useToasts } from "app/common/hooks";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";

import type { CrmEnrichmentJob } from "../../../../types/types";
import { useSfEnrichmentJobCache } from "../../hooks/useSfEnrichmentJobCache";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";

export default function useSfEnrichmentJobEditMutation() {
    const { showSuccessToast } = useToasts();

    const { updateExistingJobInCache } = useSfEnrichmentJobCache();

    return useMutation<void, unknown, CrmEnrichmentJob>({
        mutationFn: sfEnrichmentApiService.updateJob,
        onSuccess: (_data, job) => {
            updateExistingJobInCache(job);

            showSuccessToast(
                getToastItemComponent({
                    text: translate("si.crm-enrichment.job-editor.success.toast"),
                }),
            );
        },
    });
}
